import api from '../api/axios';

export interface Payroll {
  id?: number;
  employee: number;
  period: string;
  baseSalary: number;
  bonuses?: number;
  deductions?: number;
  overtime?: number;
  tax?: number;
  netSalary: number;
  currency?: string;
  status?: 'draft' | 'processed' | 'paid' | 'cancelled';
  paymentDate?: string;
  paymentMethod?: 'bank_transfer' | 'cash' | 'check' | 'other';
  notes?: string;
  workDays?: number;
  processedBy?: number;
}

const PayrollService = {
  getAll: (params?: any) => api.get('/payrolls', { params }),
  getOne: (id: number, params?: any) => api.get(`/payrolls/${id}`, { params: params || { populate: ['employee', 'processedBy'] } }),
  create: (data: Payroll) => api.post('/payrolls', { data }),
  update: (id: number, data: Partial<Payroll>) => api.put(`/payrolls/${id}`, { data }),
  delete: (id: number) => api.delete(`/payrolls/${id}`),
  processPay: (id: number) =>
    api.put(`/payrolls/${id}`, { data: { status: 'processed' } }),
  markAsPaid: (id: number, paymentDate: string) =>
    api.put(`/payrolls/${id}`, {
      data: { status: 'paid', paymentDate },
    }),
};

export default PayrollService;

